export default {
  data () {
    return {
      isShop: __AW_IS_SHOP__,
    };
  },
};
